import { createContext } from 'react'

const clinicContext = createContext()

export default clinicContext
